import _extends from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _styled from "@emotion/styled/base";
var _excluded = ["children", "onClick", "disabled", "url", "variant"];

var _templateObject;

import React from "react";
import shouldForwardProp from "@styled-system/should-forward-prop";
import { border, color, compose, css, display, flexbox, maxWidth, minHeight, space, typography } from "@catchoftheday/theme";
import { Button } from "../Button";
import { Link } from "../Link";
import { jsx as ___EmotionJSX } from "@emotion/react";
var styleProps = compose(border, space, color, display, typography, flexbox, minHeight, maxWidth);

var TagWrap = /*#__PURE__*/_styled("div", true ? {
  shouldForwardProp: shouldForwardProp,
  target: "enh4ozu0"
} : {
  shouldForwardProp: shouldForwardProp,
  target: "enh4ozu0",
  label: "TagWrap"
})("border-radius:2px;border-left:2.5px solid;", styleProps, " ", function (props) {
  if (props.url) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        text-decoration: underline;\n      "])));
  }
}, ";" + (true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

TagWrap.defaultProps = {
  p: "3px 8px 3px 6px",
  backgroundColor: "brand.primaryLight",
  display: "inline-flex",
  alignItems: "center",
  color: "text",
  fontSize: "sm",
  maxWidth: "100%",
  borderColor: "brand.primary"
};
var variants = {
  primary: {
    backgroundColor: "brand.primaryLight",
    borderColor: "brand.primary"
  },
  secondary: {
    backgroundColor: "brand.tertiaryLight",
    borderColor: "brand.tertiary"
  },
  onepass: {
    backgroundColor: "onePass.primaryLighter",
    borderColor: "onePass.primary"
  }
};
export var CalloutTag = function CalloutTag(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      url = _ref.url,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "primary" : _ref$variant,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var variantProps = variants[variant];

  if (url) {
    return ___EmotionJSX(Link, {
      href: url
    }, ___EmotionJSX(TagWrap, _extends({
      url: url
    }, otherProps, variantProps), children));
  }

  if (onClick) {
    return ___EmotionJSX(Button, {
      onClick: onClick,
      variant: "plain",
      m: 0,
      p: 0,
      minWidth: "0px!important",
      textTransform: "none"
    }, ___EmotionJSX(TagWrap, _extends({}, otherProps, variantProps), children));
  }

  return ___EmotionJSX(TagWrap, _extends({}, otherProps, variantProps), children);
};
CalloutTag.displayName = "CalloutTag";
export default CalloutTag;